export interface AnyObject {
	[property: string]: any;
}

export interface DateRange {
	start: Date;
	end: Date;
}

export interface SerializedDateRange {
	start: string;
	end: string;
}

export function deserializeDateRange(dr: DateRange | SerializedDateRange): DateRange {
	return {
		start: new Date(dr.start),
		end: new Date(dr.end),
	};
}

export interface SuccessOrFailureResponse {
	Success: boolean;
}